/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import _, { cloneDeep as _cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Table, Button, Alert } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ColorHash from 'color-hash';
import { addNotification } from 'actions/NotificationsActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import { getNameInCurrentLanguage } from 'helpers/intl';
import Entity from 'components/Entity';
import List from 'components/List';
import Loader from 'components/layout/Loader';
import Data from 'components/Data';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';
import EntityPropsUpdater from 'component/EntityPropsUpdater';
import SimplePrompt from 'components/layout/SimplePrompt';
import VariantNew from 'components/modals/VariantNew';
import { entityMetaMapping, ROLE_ERP_MASTER } from 'js/constants';
import may from 'js/security';
import Axios from 'axios';
import Modal from 'components/Modal';
import ReactTooltip from 'react-tooltip';
import FormCheckbox from 'components/forms/FormCheckbox';

/** Helper function to find if the attribute name means the values contain page count options */
const isPageCountName = name => name.includes('Seitenanzahl') || name.includes('Motive');

const attributeIdSeitenanzahl = '5e9d58f9fe80d648aa35e953';
const attributeIdAuflage = '5e9d61bc3a0211433f3be1c3';

class ItemVariantsPrint extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false, // TODO: never switched on
      showEdit: false,
      editedVariant: null,
      shownVariant: null,
      entityLoaded: false,
      entityChanged: false,
      markedVariants: [], // to save to the backend API
      savedVariants: [],
      variantsSaving: false,
      newVariantsCount: 0,
      showVendorApi: false,
      receivingData: false,
      vendorAttributes: [],
      vendorVariants: null,
      variantMotives: { name: '', values: [] },
      setAttributes: {},
      selectedMotives: [],
      defaultVatRate: props.itemEntity.getPricing().getVatRate(),
      isAttributesMissing: false,
      countryCode: 'DE',
      sortedPricesByCountries: [],
      productAttributesUrl: null, // api url used to fetch current data, caching key
    };

    this.entity = new Entity();
    this.colorHash = new ColorHash();

    if (
      props.meta.ItemVariantsList !== undefined &&
      props.meta[entityMetaMapping.itemVariant] !== undefined &&
      !props.meta[entityMetaMapping.itemVariant].pending
    ) {
      this.entity.setMeta(props.meta, 'ItemVariantsList');
    }
  }

  setSavedVariants = () => {
    const { entityLoaded, entity, savedVariants } = this.state;

    const hasVariantsList = entityLoaded && entity?.getList().length;
    if (!hasVariantsList) {
      // retry
      window.setTimeout(this.setSavedVariants, 1000);
      return;
    }

    const variants = entity.getList();

    const addedVariants = variants.map(variant => ({
      id: variant.getId(),
      attributes: variant.getAttributes(),
      vendorAttributes: variant.getVendorAttributes() ?? [],
      pricing: variant.getPricing(),
      deliveryTimes: variant.getDeliveryTimes(),
      ident: variant.getIdent(),
      itemCountry: variant.getItemCountry(),
      isActivePriceVariant: variant.getIsActivePriceVariant(),
    }));

    let updatedSavedVariants;
    if (savedVariants.length === 0) {
      // Wenn savedVariants leer ist, übernehmen Sie einfach alle Varianten aus addedVariants
      updatedSavedVariants = addedVariants;
    } else {
      // Update existing variants based of the id
      updatedSavedVariants = savedVariants.map(existingVariant => {
        const matchingNewVariant = addedVariants.find(newVariant => newVariant.id === existingVariant.id);
        if (matchingNewVariant) {
          return matchingNewVariant;
        } else {
          return existingVariant;
        }
      });
    }

    const sortedPricesByCountries = this.mapByCountry(updatedSavedVariants);
    this.setState({ savedVariants: updatedSavedVariants, sortedPricesByCountries });

  };

  /**
   * Transform array of variants to array of objects with country prices.
   * Pure function, no side effects.
   * @param {array} variants
   * @returns array of objects like [ {id: {DE: pricingObjectDe, ES: pricingObjectEs}, ... ]
   */
  mapByCountry = variants =>
    variants.map(({ id, itemCountry }) => {
      const countryPrices = Object.fromEntries(itemCountry.map(({ country, pricing }) => [country, pricing]));

      return { [id]: countryPrices };
    });

  setSortedPricedByCountries = () => {
    const { savedVariants } = this.state;
    const sortedPricesByCountries = this.mapByCountry(savedVariants);
    this.setState({ sortedPricesByCountries });
  };

  addSortedCountryPrices = (variantId, name, value) => {
    const { sortedPricesByCountries, countryCode } = this.state;
    const index = sortedPricesByCountries.findIndex(obj => variantId in obj);
    if (index > -1) {
      const prices = sortedPricesByCountries[index][variantId];
      if (Object.hasOwnProperty.apply(prices, [countryCode])) {
        prices[countryCode][name] = value;
      } else {
        const itemCountryData = {
          country: countryCode,
          pricing: this.createPricing(),
        };
        itemCountryData.pricing[name] = value;
        sortedPricesByCountries[index][variantId][countryCode] = itemCountryData.pricing;
      }
    } else {
      const pricing = this.createPricing();
      pricing[name] = value;
      const byCountries = { [variantId]: {} };
      byCountries[variantId][countryCode] = pricing;
      sortedPricesByCountries.push(byCountries);
    }

    this.setState({ sortedPricesByCountries });
  };

  componentDidMount = () => {
    this.setSavedVariants();
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      meta,
      data,
      variantNewFormStatus,
      variantEditFormStatus,
      doNotify,
    } = this.props;

    let mustUpdate = false;

    // variant was saved to the item
    if (prevProps.variantNewFormStatus.pending && !variantNewFormStatus.pending && !variantNewFormStatus.hasError) {
      this.closeNew();
      doNotify(1, messages.variant_saved);
    }

    // variant was saved to the item
    if (prevProps.variantEditFormStatus.pending && !variantEditFormStatus.pending && !variantEditFormStatus.hasError) {
      this.closeEdit();
      doNotify(1, messages.variant_saved);
    }

    if (prevProps.data.data.list.length !== data.data.list.length) {
      this.entity.setData({ list: data.data.list });
      if (this.entity.getMetaLoaded()) {
        mustUpdate = true;
      }
      this.setSavedVariants();
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData({ list: data.data.list });
      if (this.entity.getMetaLoaded()) {
        mustUpdate = true;
      }
    }

    if (
      meta[entityMetaMapping.itemVariant] !== undefined &&
      !meta[entityMetaMapping.itemVariant].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, 'ItemVariantsList');
      if (this.entity.getDataLoaded()) {
        mustUpdate = true;
      }
    }

    if (mustUpdate) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ entityLoaded: true, entity: this.entity });
    }
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  handleClick = variantId => {
    const {
      appIntl: { urlPrefix },
      itemEntity: { getId },
    } = this.props;

    this.props.history.push(`${urlPrefix}account/items/${getId()}/variants/${variantId}`);
  };

  handleRemoveClick = (e, variantId) => {
    e.preventDefault();
    e.stopPropagation();
    const {
      deleteVariant,
      itemEntity: { getId },
    } = this.props;

    const { markedVariants: marked, savedVariants: saved } = this.state;
    const notTheId = ({ id }) => id !== variantId;
    const markedVariants = marked.filter(notTheId);
    const savedVariants = saved.filter(notTheId);
    const sortedPricesByCountries = this.mapByCountry(savedVariants);

    this.setState({ markedVariants, savedVariants, sortedPricesByCountries }, () => {
      deleteVariant(getId(), variantId);
    });
  };

  findMarkedOrSavedVariant = (variantId, prevMarkedVariants) => {
    const { markedVariants: marked, savedVariants: saved } = prevMarkedVariants;
    const { doNotify } = this.props;

    const markedVariants = [...marked];
    const eqVariantId = ({ id }) => id === variantId;

    let markedVariant = marked.find(eqVariantId);
    if (!markedVariant) {
      const savedVariant = saved.find(eqVariantId);
      if (!savedVariant) {
        doNotify(0, 'Error: Variant not found');
        throw new Error('Variant not found');
      }
      markedVariants.push(savedVariant);
      markedVariant = savedVariant;
    }

    return { markedVariant, markedVariants };
  };

  /**
   * Find the variant, updated it and add it to markedVariants to save on backend.
   * Look in marked- and in saved- variants by id.
   * Bad pattern: calls another setState in update function after setting state.
   */
  markVariant = (variantId, name, value, propName, attributeName = '') => {
    const { countryCode } = this.state;
    this.setState(prevState => {
        const { markedVariant, markedVariants } = this.findMarkedOrSavedVariant(variantId, prevState);
        if (['attributes', 'vendorAttributes'].includes(propName)) {
          const attribute = markedVariant[propName].find(({ id }) => id === name);
          if (!attribute) {
            markedVariant[propName].push({
              id: name,
              name: attributeName,
              values: [
                {
                  value: [{ name: value }],
                },
              ],
            });
          } else {
            attribute.values[0].value[0].name = value;
          }
        } else if (propName === 'isActivePriceVariant') {
          markedVariant[propName] = value;
        } else {
          // deliveryTimes, pricing, ident
          const markedVariantCountry = markedVariant.itemCountry.find(({ country }) => country === countryCode);
          if (!markedVariantCountry) {
            const itemCountryData = {
              country: countryCode,
              pricing: this.createPricing(),
            };
            itemCountryData.pricing[name] = value;
            markedVariant.itemCountry.push(itemCountryData);
          } else {
            markedVariantCountry.pricing[name] = value;
          }
        }
        const updatedMarkedVariants = [...markedVariants]; // Clone the array
        return { markedVariants: updatedMarkedVariants };
      },
      () => {
        this.addSortedCountryPrices(variantId, name, value);
      }
    );
  };

  newVariant = () => {
    const { newVariantsCount, savedVariants, countryCode } = this.state;
    const newVariantsCounter = newVariantsCount + 1;
    const newVariant = {
      id: newVariantsCounter + '_newVariant',
      attributes: [],
      vendorAttributes: [],
      pricing: {},
      deliveryTimes: {},
      ident: {},
      itemCountry: [],
      isActivePriceVariant: false,
    };

    const itemCountryData = {
      country: countryCode,
      pricing: this.createPricing(),
    };
    newVariant.itemCountry.push(itemCountryData);
    savedVariants.push(newVariant);
    this.setState(
      {
        newVariantsCount: newVariantsCounter,
        savedVariants,
      },
      () => {
        this.setSortedPricedByCountries();
        this.forceUpdate();
      }
    );
  };

  saveVariants = () => {
    const { markedVariants } = this.state;
    if (markedVariants.length > 0) {
      this.setState({
        variantsSaving: true,
      });
      const params = JSON.stringify(markedVariants);
      Axios.put('/api/items/' + this.props.itemEntity.getId() + '/variants.json', { json: params })
        .then(() => {
          this.setState({
            markedVariants: [],
            variantsSaving: false,
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  handleRemoveAllVariantsClick = e => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteAllVariants, itemEntity } = this.props;

    this.setState({ savedVariants: [], sortedPricesByCountries: [] }, () => {
      deleteAllVariants(itemEntity.getId());
    });
  };

  /**
   * Fetch data from the backend
   * that loads it from json files on S3
   */
  getVendorPrices = () => {
    const {
      itemEntity,
      intl: { messages },
      doNotify,
    } = this.props;
    const vendorClientId = itemEntity?.getVendor()?.getUsername();
    const productId = itemEntity?.getIdent()?.getVendorId();

    if (!vendorClientId || !productId) {
      // alert(messages.no_vendor_id); // replace with notification action
      doNotify(0, messages.no_vendor_id);

      return;
    }

    const { countryCode, productAttributesUrl } = this.state;
    const lcCountryCode = countryCode.toLowerCase();

    /** @see ItemsBundle\Controller\VariantsController::getVendorProductattributesAction */
    const url = `/api/vendors/${vendorClientId}/productattributes/${productId}.json?countryCode=${lcCountryCode}`;

    if (productAttributesUrl === url) {
      // already loaded. Re-use vendorAttributes, vendorVariants, variantMotives
      this.setState({
        showVendorApi: true,
        receivingData: false,
        setAttributes: {},
      });

      return;
    }

    this.setState({
      productAttributesUrl: url,
      receivingData: true,
    });

    Axios.get(url)
      .then(({ data: { attributes, variants: vendorVariants } = {} }) => {
        const vendorAttributes = [];
        const variantMotives = {
          name: '',
          values: [],
        };

        Object.entries(attributes).forEach(([name, vendorAttributeNames]) => {
          // TODO: why handle these 2 differently?
          if (isPageCountName(name)) {
            // TODO: when both Seitenanzahl and Motive are present for the variant, the last one will be used. Is that wanted?
            variantMotives.name = name;
            variantMotives.values = vendorAttributeNames.map(value => ({ value, label: value }));
          } else {
            vendorAttributes.push({
              name,
              values: vendorAttributeNames,
            });
          }
        });

        vendorAttributes.sort((a, b) => a.name.localeCompare(b.name));

        this.setState({
          showVendorApi: true,
          receivingData: false,
          vendorAttributes,
          vendorVariants,
          variantMotives,
          setAttributes: {},
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  createPricing = (quantity = {}) => {
    const { defaultVatRate } = this.state;

    return {
      price: parseFloat(quantity.Standard_price ?? 0),
      vendorPrice: parseFloat(quantity.Standard_price_purchase ?? 0),
      expressPrice: parseFloat(quantity.Express_price ?? 0),
      vendorExpressPrice: parseFloat(quantity.Express_price_purchase ?? 0),
      overnightPrice: parseFloat(quantity.Overnight_price ?? 0),
      vendorOvernightPrice: parseFloat(quantity.Overnight_price_purchase ?? 0),
      samedayPrice: parseFloat(quantity.Sameday_price ?? 0),
      vendorSamedayPrice: parseFloat(quantity.Sameday_price_purchase ?? 0),
      currency: 'EUR',
      vatRate: quantity ? defaultVatRate : 0,
    };
  };

  createAttributeAuflage = ({ quantity }) => ({
    id: attributeIdAuflage,
    name: [{ name: 'Auflage', lang: 'de' }],
    values: [{ value: [{ name: quantity }] }],
  });

  createAttributeSeitenanzahl = pageAmount => ({
    id: attributeIdSeitenanzahl,
    name: [{ name: 'Seitenzahl', lang: 'de' }],
    values: [{ value: [{ name: pageAmount }] }],
  });

  getVendorVariants = () => {
    const {
      vendorVariants,
      newVariantsCount,
      savedVariants,
      markedVariants,
      setAttributes,
      selectedMotives,
      countryCode,
    } = this.state;

    let pageAmount = 0;
    let newVariantsCounter = newVariantsCount;
    let isAllQuantitiesProduct = false;
    const _savedVariants = _cloneDeep(savedVariants);
    const _markedVariants = _cloneDeep(markedVariants);

    vendorVariants.forEach(({ attributes, quantities }) => {
      if (attributes.length === 0) {
        // no attributes
        isAllQuantitiesProduct = true;
      }

      const isSelected = attributes.every(({ attribute_name: name, attribute_value: value }) => {
        if (!isPageCountName(name)) {
          if (setAttributes[name] !== value) {
            return false;
          }
        } else if (selectedMotives.includes(parseInt(value, 10).toString())) {
          pageAmount = parseInt(value, 10);
        } else if (selectedMotives.includes(value)) {
          // string value
        } else {
          return false;
        }

        return true;
      });

      if (!isSelected) {
        console.log(this.constructor.name, 'getVendorVariants() not selected');

        return;
      }

      pageAmount = Math.max(pageAmount, 1);

      quantities.forEach(quantity => {
        const { quantity_id: quantityId } = quantity;

        // search functions
        const matchQuantityId = ({ ident: { vendorId } }) => vendorId === quantityId;
        const matchCountry = ({ country }) => country === countryCode;

        const itemCountryData = {
          country: countryCode,
          pricing: this.createPricing(quantity),
        };

        const isCreateNewVariant = isAllQuantitiesProduct || !savedVariants.find(matchQuantityId);

        if (isCreateNewVariant) {
          newVariantsCounter++;
          const newVariant = {
            id: `${newVariantsCounter}_newVariant`,
            attributes: [this.createAttributeAuflage(quantity), this.createAttributeSeitenanzahl(pageAmount)],
            vendorAttributes: [],
            pricing: this.createPricing(quantity),
            deliveryTimes: {
              standardTo: parseInt(quantity.Standard_to + 1, 10),
              expressTo: parseInt(quantity.Express_to + 1, 10),
              overnightTo: parseInt(quantity.Overnight_to + 1, 10),
              sameday: parseInt(quantity.Sameday_to + 24, 10),
            },
            ident: {
              vendorId: quantityId,
            },
            itemCountry: [itemCountryData],
          };

          _savedVariants.push(newVariant);
          _markedVariants.push(newVariant);
        } else {
          const savedVariant = _savedVariants.find(matchQuantityId);
          const markedVariant = _markedVariants.find(matchQuantityId);

          // find array element using provided search function. Replace found with the value or push one.
          const addOrReplace = (arr, searchFn, value) => {
            const index = arr.findIndex(searchFn);
            if (index === -1) {
              arr.push(value);
            } else {
              arr.splice(index, 1, value);
            }
          };

          addOrReplace(savedVariant.itemCountry, matchCountry, itemCountryData);

          if (markedVariant) {
            addOrReplace(markedVariant.itemCountry, matchCountry, itemCountryData);
          } else {
            _markedVariants.push(savedVariant);
          }
        }
      });
    });

    // update the state
    const stateUpdate = {
      newVariantsCount: newVariantsCounter,
      savedVariants: _savedVariants,
      markedVariants: _markedVariants,
    };

    if (_savedVariants.length === 0) {
      stateUpdate.isAttributesMissing = true;
    } else {
      stateUpdate.showVendorApi = false;
    }

    this.setState(stateUpdate, this.setSortedPricedByCountries);
  };

  setSelectValue = (name, option) => {
    const { setAttributes } = this.state;
    setAttributes[name] = option;
    this.setState({ setAttributes });

    const { itemEntity, changeEntity } = this.props;
    const entityQAttributes = [];
    Object.entries(setAttributes).forEach(([name, value]) => {
      const updatedAttribute = { name, value };
      entityQAttributes.push(updatedAttribute);
    });
    const newEntity = { ...itemEntity.updateValue('lastQueriedAttributes', entityQAttributes, []) };
    changeEntity(newEntity);
  };

  doublePages = () => {
    const { savedVariants } = this.state;
    _.forEach(savedVariants, variant => {
      const thisVariantAttribute = _.find(variant.attributes, ['id', attributeIdSeitenanzahl]);
      this.markVariant(
        variant.id,
        attributeIdSeitenanzahl,
        thisVariantAttribute.values[0].value[0].name * 2,
        'attributes',
        'Seitenzahl'
      );
    });
  };

  /**
   * Set isActivePriceVariant for the selected variant and unset for all other variants
   * @param {string} variantId
   * @param {bool} checked
   */
  deactivateOtherVariants = (variantId, checked) => {
    const { doNotify } = this.props;

    this.setState(({ savedVariants: saved, markedVariants: marked }) => {
      const markedVariants = [...marked];

      const findOrAddMarkedVariant = someVariantId => {
        // find variant by id in marked or saved
        const eqVariantId = ({ id }) => id === someVariantId;

        let markedVariant = marked.find(eqVariantId);
        if (!markedVariant) {
          const savedVariant = saved.find(eqVariantId);
          if (!savedVariant) {
            doNotify(0, 'Error: Variant not found');
            throw new Error('Variant not found');
          }
          markedVariants.push(savedVariant);
          markedVariant = savedVariant;
        }

        return markedVariant;
      };

      // loop through savedVariants to update some
      // ensure changed variants are also added to markedVariants
      const savedVariants = saved.map(variant => {
        const updatedVariant = { ...variant };
        const { id, isActivePriceVariant } = updatedVariant;

        if (id === variantId) {
          // this.markVariant(id, name, checked, name);
          findOrAddMarkedVariant(id).isActivePriceVariant = !!checked;
          updatedVariant.isActivePriceVariant = !!checked;
        } else if (isActivePriceVariant) {
          // this.markVariant(id, name, false, name);
          findOrAddMarkedVariant(id).isActivePriceVariant = false;
          updatedVariant.isActivePriceVariant = false;
        }

        return updatedVariant;
      });

      // also update the byCountries view on savedVariants
      const sortedPricesByCountries = this.mapByCountry(savedVariants);

      return { savedVariants, markedVariants, sortedPricesByCountries };
    });
  };

  render() {
    const {
      intl: { messages },
      itemEntity,
      itemEntityLoaded,
      appIntl,
      data,
      user,
      disabled,
    } = this.props;

    const {
      shownIndex,
      entityLoaded,
      entity,
      markedVariants,
      variantsSaving,
      savedVariants,
      receivingData,
      showVendorApi,
      sortedPricesByCountries,
      vendorAttributes,
      vendorVariants,
      variantMotives,
      isAttributesMissing,
      countryCode,
    } = this.state;

    const quantityCount = vendorVariants?.reduce((acc, { quantities }) => acc + quantities.length, 0) || 0;

    const countryOptions = [
      [messages.countries_for_prices.de, 'DE'],
      [messages.countries_for_prices.at, 'AT'],
      [messages.countries_for_prices.ch, 'CH'],
      [messages.countries_for_prices.es, 'ES'],
    ];

    const columns = []; // [messages.image];
    let variantAttributes;
    if (itemEntityLoaded) {
      variantAttributes = itemEntity.getVariants().getAttributes();
      if (variantAttributes !== null) {
        _.forEach(variantAttributes, variantAttribute => {
          columns.push(getNameInCurrentLanguage(variantAttribute.getName(), appIntl));
        });
      }
    }

    const standardColumnTitles = [
      '💰 Standard (€)',
      '🚚 Standard (T)',
      '💰 Express (€)',
      '🚚 Express (T)',
      '💰 Overnight (€)',
      '🚚 Overnight (T)',
      '💰 Sameday (€)',
      '🚚 Sameday (H)',
      '% MwSt.',
      'CC QTY ID',
      'Vendor QTY ID',
      'Target variant price (€)',
      ' ',
    ];
    columns.push(...standardColumnTitles);

    const tBody =
      entityLoaded &&
      entity &&
      sortedPricesByCountries.length > 0 &&
      savedVariants.map((variant, variantIndex) => {
        const variantAttributeCells = [];
        const variantId = variant.id;
        const isActivePriceVariant = !!variant.isActivePriceVariant;
        const countryPrice = sortedPricesByCountries[variantIndex]?.[variantId]?.[countryCode];

        if (variantAttributes !== null) {
          variantAttributes.forEach(variantAttribute => {
            const attributeId = variantAttribute.getId();
            const attributeName = variantAttribute.getName();

            // attributes that define a variant
            const thisVariantAttribute = variant.attributes.find(({ id }) => id === attributeId); // attribute value for current variant
            variantAttributeCells.push(
              <td class="v-align-middle" key={attributeId}>
                <FormInput
                  type="number"
                  name={attributeId}
                  value={
                    typeof thisVariantAttribute !== 'undefined' && thisVariantAttribute.values[0].value[0].name
                      ? thisVariantAttribute.values[0].value[0].name
                      : 0
                  }
                  onChange={(name, value) => this.markVariant(variantId, name, value, 'attributes', attributeName)}
                  disabled={disabled}
                />
              </td>
            );
          });
        }

        const rowClassName = (variantIndex === shownIndex ? 'shown ' : '') + (variantIndex % 2 ? 'even ' : 'odd ');

        return (
          <tr
            key={variantId}
            class={rowClassName}
            onClick={() => {
              // this.handleClick(variant.getId());
            }}
          >
            {variantAttributeCells}
            <td class="v-align-middle">
              <FormInput
                type="number"
                name="price"
                value={countryPrice?.price || 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'pricing')}
                disabled={disabled}
              />
              <input type="hidden" name="vendorPrice" value={countryPrice?.vendorPrice || 0} />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="standardTo"
                value={variant.deliveryTimes.standardTo ? variant.deliveryTimes.standardTo : 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'deliveryTimes')}
                disabled={disabled}
              />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="expressPrice"
                value={countryPrice?.expressPrice || 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'pricing')}
                disabled={disabled}
              />
              <input type="hidden" name="vendorExpressPrice" value={countryPrice?.vendorExpressPrice || 0} />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="expressTo"
                value={variant.deliveryTimes.expressTo ? variant.deliveryTimes.expressTo : 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'deliveryTimes')}
                disabled={disabled}
              />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="overnightPrice"
                value={countryPrice?.overnightPrice || 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'pricing')}
                disabled={disabled}
              />
              <input type="hidden" name="vendorOvernightPrice" value={countryPrice?.vendorOvernightPrice || 0} />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="overnightTo"
                value={variant.deliveryTimes.overnightTo ? variant.deliveryTimes.overnightTo : 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'deliveryTimes')}
                disabled={disabled}
              />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="samedayPrice"
                value={countryPrice?.samedayPrice || 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'pricing')}
                disabled={disabled}
              />
              <input type="hidden" name="vendorSamedayPrice" value={countryPrice?.vendorSamedayPrice || 0} />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="sameday"
                value={variant.deliveryTimes.sameday ? variant.deliveryTimes.sameday : 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'deliveryTimes')}
                disabled={disabled}
              />
            </td>
            <td className="v-align-middle noborder">
              {/* Todo whats this itemEntitypricing */}
              <FormAutocomplete
                name="vatRate"
                value={countryPrice?.vatRate || itemEntity.getPricing().getVatRate()}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'pricing')}
                options={
                  user &&
                  user.financial &&
                  user.financial.vat_rates &&
                  user.financial.vat_rates &&
                  user.financial.vat_rates.map(vatRate => {
                    return { value: vatRate, label: vatRate + '%' };
                  })
                }
                complete
                disabled={disabled}
              />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="sku"
                value={variant.ident.sku ? variant.ident.sku : 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'ident')}
                disabled={disabled}
              />
            </td>
            <td className="v-align-middle">
              <FormInput
                type="number"
                name="vendorId"
                value={variant.ident.vendorId ? variant.ident.vendorId : 0}
                onChange={(name, value) => this.markVariant(variantId, name, value, 'ident')}
                disabled={disabled}
              />
            </td>
            <td className="v-align-middle">
              <div className="checkbox check-success">
                <input
                  id={`check_${variantId}`}
                  disabled={disabled}
                  name="isActivePriceVariant"
                  type="checkbox"
                  value
                  checked={isActivePriceVariant}
                  onChange={() => this.deactivateOtherVariants(variantId, !isActivePriceVariant)}
                />
                <label htmlFor={`check_${variantId}`} style={{ paddingLeft: 0, marginRight: 0 }} />
              </div>
            </td>
            <td class="v-align-middle text-right">
              {may('ROLE_ERP_MASTER', user.roles) ? (
                <SimplePrompt
                  onSuccess={e => {
                    this.handleRemoveClick(e, variantId);
                  }}
                />
              ) : null}
            </td>
          </tr>
        );
      });

    return (
      <div class="clearfix padding-20 sm-padding-10">
        {itemEntityLoaded && itemEntity.getVariants().getAttributes().length > 0 ? (
          <Row>
            {itemEntity.getId() !== null ? (
              <List
                noRender
                listName="itemVariants"
                url={'/api/items/' + itemEntity.getId() + '/variants.json'}
                list={data}
              />
            ) : null}
            <Data dataName="itemVariant" />

            <Col xs={12}>
              <Modal
                show={showVendorApi}
                onHide={() => {
                  this.setState({ showVendorApi: false });
                }}
                bsSize="lg"
              >
                <ReactTooltip id="top" place="top" effect="solid" />
                <Modal.Header closeButton>
                  <Modal.Title>{messages.select_vendor_product}</Modal.Title>
                  {isAttributesMissing ? (
                    <Alert bsStyle="danger">{messages.vendor_item_missing_attributes}</Alert>
                  ) : (
                    <Alert bsStyle="info">{messages.vendor_item_save_attributes}</Alert>
                  )}
                </Modal.Header>
                <Modal.Body>
                  <div className="row">
                    {vendorAttributes.length === 0 ? (
                      <>
                        <p>{messages.vendor_item_has_no_attributes}</p>
                        <p>
                          <FormattedMessage id="vendor_item_all_n_quantities" values={{ quantityCount }} />
                        </p>
                      </>
                    ) : (
                      vendorAttributes.map(({ name, values }) => (
                        <div className="col-md-3" key={name}>
                          <FormAutocomplete
                            name={name}
                            label={name}
                            value={null}
                            onChange={this.setSelectValue}
                            options={values.map(value => ({ value, label: value }))}
                            complete
                          />
                        </div>
                      ))
                    )}

                    <div className="col-md-12">
                      <FormCheckbox
                        label={variantMotives.name}
                        name="motive"
                        options={variantMotives.values}
                        onChange={(_, selectedMotives) => this.setState({ selectedMotives })}
                      />
                    </div>
                  </div>
                  <Button bsSize="large" bsStyle="info" onClick={this.getVendorVariants}>
                    <i class="fas fa-search" /> {messages.get_vendor_price}
                  </Button>
                </Modal.Body>
              </Modal>

              {data.pending ? (
                <Loader />
              ) : (
                <Table responsive hover id="auflagen">
                  <thead>
                    <tr>
                      {columns.map(columnTitle => (
                        <th key={columnTitle} className={columnTitle === messages.actions ? 'text-right' : ''}>
                          {columnTitle}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <ReactCSSTransitionGroup
                    transitionName="tablerows"
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={1}
                    component="tbody"
                  >
                    {tBody}
                  </ReactCSSTransitionGroup>
                </Table>
              )}
              <div class="m-t-10 last-queried-attributes">
                <div>
                  <h5>{messages.last_queried_attributes}</h5>
                </div>
                <ul>
                  {itemEntity?.data?.last_queried_attributes?.map((attr, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={i}>
                      {attr?.name}: {attr?.value}
                    </li>
                  ))}
                </ul>
              </div>

              <div class="m-t-10">
                <FormAutocomplete
                  onChange={(name, value) => this.setState({ countryCode: value })}
                  label={messages.choose_country}
                  name="type"
                  value={countryCode}
                  options={countryOptions.map(option => {
                    return { label: option[0], value: option[1] };
                  })}
                />
                <Button bsSize="large" onClick={this.newVariant}>
                  {messages.add_variant_line}
                </Button>{' '}
                <Button bsSize="large" onClick={this.doublePages}>
                  Seitenzahlen verdoppeln
                </Button>{' '}
                <Button bsSize="large" disabled={receivingData} bsStyle="warning" onClick={this.getVendorPrices}>
                  <i className={'fa-fw ' + (receivingData ? ' fa fa-circle-notch fa-spin' : 'fas fa-cloud-download')} />
                  {' ' + messages.get_vendor_prices}
                </Button>{' '}
                <Button
                  bsSize="lg"
                  disabled={variantsSaving}
                  bsStyle={markedVariants.length > 0 ? 'primary' : 'default'}
                  onClick={this.saveVariants}
                >
                  <i class={'fa-fw ' + (variantsSaving ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />
                  {' Auflagen speichern'}
                </Button>{' '}
                {may(ROLE_ERP_MASTER, user.roles) && (
                  <SimplePrompt
                    disabled={variantsSaving || data?.data?.count === 0}
                    buttonLabel={messages.remove_all_item_variant}
                    bsSize="lg"
                    className="btn-lg"
                    onSuccess={e => this.handleRemoveAllVariantsClick(e)}
                  />
                )}
              </div>
            </Col>
          </Row>
        ) : null}

        {itemEntityLoaded && itemEntity.getVariants().getAttributes().length === 0 ? (
          <Row>
            <Col xs={12}>{messages.vendor_item_must_define_attributes}</Col>
          </Row>
        ) : null}

        <VariantNew item={itemEntity} show={this.state.showNew} close={this.closeNew} />
      </div>
    );
  }
}

ItemVariantsPrint.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.list.itemVariants,
    meta: state.entityMeta,
    variantNewFormStatus: state.formStatus.variantNew,
    variantEditFormStatus: state.formStatus.variantEdit,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    deleteVariant: (itemId, variantId) => {
      deleterDispatchHelper('variant', '/api/items/' + itemId + '/variants/' + variantId + '.json', dispatch);
    },
    deleteAllVariants: itemId => {
      deleterDispatchHelper('variant', '/api/items/' + itemId + '/variants.json', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ItemVariantsPrint)
  )
);
